<template>
  <Spinner
    :size="resolvedSize"
    :color="resolvedColor"
    :aria-label="props.ariaLabel ?? 'Loading'"
    class="p-loading"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Spinner } from '@p-utilities/vue'
import type { SpinnerSize, SpinnerColor } from '@p-utilities/vue'

const props = defineProps<{
  size?: SpinnerSize | 'sm' | 'md' | 'lg'
  color?: SpinnerColor | 'fg-accent' | 'fg-fix-white' | 'fg-primary' | 'fg-danger'
  ariaLabel?: string
}>()

const SIZE_MAP: Record<string, SpinnerSize> = {
  sm: 'small',
  md: 'medium',
  lg: 'medium',
}
const resolvedSize = computed<SpinnerSize>(() => {
  const s = props.size
  if (!s) return 'medium'
  if (s === 'small' || s === 'medium') return s
  return SIZE_MAP[s] ?? 'medium'
})

const COLOR_MAP: Record<string, SpinnerColor> = {
  'fg-accent': 'green',
  'fg-fix-white': 'white',
  'fg-primary': 'system',
  'fg-danger': 'red',
}
const resolvedColor = computed<SpinnerColor>(() => {
  const c = props.color
  if (!c) return 'green'
  if (c === 'green' || c === 'system' || c === 'white' || c === 'red') return c
  return COLOR_MAP[c] ?? 'green'
})
</script>
